import ManageStudentForm from "./Forms/ManageStudentForm";
import ManageTeacherForm from "./Forms/ManageTeacherForm";
import ManageClassForm from "./Forms/ManageClassForm";
import ManageAdminForm from "./Forms/ManageAdminForm";
import { useContext } from "react";
import { EntityManagementContext } from "../context/EntityManagementContext";

// Popup that appears when browser window is narrow; through this
// interface, permitted users can modify or create entity records.
function ManageEntityPopup() {
    const { 
        mode, 
        exit, 
        type
    } = useContext(EntityManagementContext);

    // When a user clicks outside the popup area, close the popup.
    const clickOutsidePopup = (event) => {
        let popup = document.getElementById("new-user-popup");
        if (!(event.target == popup || popup.contains(event.target))) {
            exit();
        }
    }

    return (
        <div id = "popup-background" onClick={clickOutsidePopup}> {/* Popup background */}
            <div id = "new-user-popup">
                <div id="new-user-header">
                    <p>{mode} {type}</p>
                    <button id="x-out" onClick={exit}>X</button>
                </div>
                {/* Show correct form depending on current entity type */}
                <div id="form-body" style={{minWidth: "400px"}}>
                    {type == "Student" ? 
                        (<ManageStudentForm/>)
                    : (type == "Teacher" ? 
                        (<ManageTeacherForm/>)
                    : (type == "Admin" ? 
                        (<ManageAdminForm/>)
                    : (type == "Class") ?
                        (<ManageClassForm/>)
                    : null))}
                </div>                
            </div>
        </div>
    );
}

export default ManageEntityPopup;